/* eslint-disable jsx-a11y/iframe-has-title */
import moment from "moment";
import React, { useRef, useState } from "react";
//@ts-ignore
import { QRCode } from "react-qr-svg";
interface Props {
  sku: any[];
  refPrint: (e: any) => void;
}

export function PrinteSku4x3(props: Props) {
  const ref = useRef<HTMLDivElement>(null);
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const [doc, setDoc] = useState("");

  const onPrintClicked = () => {
    if (ref.current && iframeRef.current) {
      setDoc(
        `<style type="text/css">
          @import url(https://fonts.googleapis.com/css?family=Nokora&display=swap);
        </style>
        <style>
          html, body { 
            margin: 0; 
            padding: 0; 
            text-align: center; 
            color: '#3E4B5B'; 
            font-family: "Nokora", "Avenir Next W01", "Proxima Nova W01", "Rubik", -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
          } 
          
          @media print { 
            @page {
              margin: 0;
              padding: 0;
            }

            .pagebreak { 
              clear: both !important; 
              page-break-after: always; 
              page-break-before: always !important; 
            } 
            
            .center { 
              display: flex; 
              justify-content: center; 
              flex-direction: column; 
              align-items:center;
              font-size: 9.52px;
            }
          }
        </style>
        <div>` +
          ref.current.innerHTML +
          "</div><script>window.print(); /*" +
          Math.random().toString() +
          "*/</script>",
      );
    }
  };

  return (
    <div>
      <div>
        <button onClick={onPrintClicked} ref={props.refPrint} style={{ display: "none" }}>
          Print
        </button>
      </div>
      <div
        ref={ref}
        style={
          {
            // position: "fixed",
            // width: 1,
            // height: 1,
            // left: -1000,
            // top: -1000,
          }
        }
      >
        {props.sku.map((x, i) => {
          return x.sku.map((y: any, j: number) => {
            const toPrintQr: any = { z: Number(y.sku_id), prt: moment().format("YYYY-MM-DD") };
            if (y.expiredDate) {
              toPrintQr.exp = y.expiredDate;
            }

            return (
              <div className="pagebreak" style={{ width: "3.7cm", height: "100%", margin: "auto" }} key={i + j}>
                <div className="center" style={{ padding: 1, marginTop: 1, marginRight: 5, marginLeft: -6 }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      width: "100%",
                      alignItems: "center",
                      margin: "auto 0",
                    }}
                  >
                    <div style={{ width: "100%", textAlign: "left", maxHeight: 60, overflow: "hidden" }}>
                      <div>
                        {String(y.sku_id).includes("SHP") ? (
                          <strong style={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>
                            <strong style={{ marginLeft: "1rem" }}>SHP</strong>
                            <strong style={{ marginLeft: "1rem" }}>{String(y.sku_id).replace("SHP", "")}</strong>
                            <span style={{ marginLeft: "1rem", width: 50, fontSize: 9, fontWeight: "normal" }}>
                              {x.supplier.name}
                            </span>
                          </strong>
                        ) : (
                          <small style={{ fontSize: "6pt" }}>
                            {x.price && (
                              <>
                                <strong>${x.price}</strong> |{" "}
                              </>
                            )}{" "}
                            {x.code}
                          </small>
                        )}
                      </div>
                      <small style={{ fontSize: "6pt" }}>
                        {y.expiredDate && <strong>exp: {y.expiredDate}</strong>}
                      </small>
                      {y.color && y.size && (
                        <div
                          style={{
                            fontSize: "6pt",
                            display: "-webkit-box",
                            WebkitLineClamp: 4,
                            WebkitBoxOrient: "vertical",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {`${y.sku_id + "-" + moment(new Date()).format("YYMMDD")}\n${String(
                            y.color,
                          ).toUpperCase()}|${String(y.size).toUpperCase()}`}
                        </div>
                      )}
                    </div>
                    <div style={{ marginTop: "5px" }}>
                      <QRCode
                        value={String(y.sku_id).includes("SHP") ? y.sku_id : JSON.stringify(toPrintQr)}
                        style={{ width: 60, height: 60 }}
                        level="Q"
                      />
                    </div>
                  </div>
                </div>
              </div>
            );
          });
        })}
      </div>
      <iframe
        style={{
          position: "fixed",
          width: 1,
          height: 1,
          left: -1000,
          top: -1000,
        }}
        srcDoc={doc}
        ref={iframeRef}
      ></iframe>
    </div>
  );
}
